<template>
  <b-container id="body-container" style="padding: 0px" fluid>
    <b-row class="justify-content-center mb-5">
      <b-col cols="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="4" md="4">
            <span>
              <h4 class="text-blackish title-body">Company Directory</h4>
            </span>
          </b-col>
          <b-col cols="3" md="8">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>
                the Fastest Growing Teams and Companies across the entire US.
                Fast growing companies and teams have revenue or funding to
                afford employees.
              </h5>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row align-h="start" align-v="end">
      <b-col
        cols="10"
        offset="2"
        offset-md="2"
        md="10"
        class="products-links-container"
      >
        <div v-for="(locations, name) in locationLinks" v-bind:key="name">
          <div class="row">
            <div class="title-container">
              <p class="link-title">{{ name }}</p>
              <div class="color-line"></div>
            </div>
          </div>

          <b-row>
            <b-col
              cols="6"
              v-for="link in locations"
              v-bind:key="link.id"
              class="link-list"
            >
              <a :href="link.url" class="link">{{ link.title }}</a>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/_components/main-card.sass
@import @/sass/screens/home/header.sass

.title-container
  margin-top: 20px
  margin-bottom: 20px
</style>

<script>
// components
// import MainCard from '@/components/mainCardHome'
// import ourFleet from '@/components/ourFleetCard'
// import ourFleetOG from '@/components/ourFleetCardOriginal'
// import HostCard from '@/components/hostCard'
import VueScrollTo from "vue-scrollto";

var locationLinksJson = require("@/data/location.json");
// data
// import { guests, yourHosts } from '@/data/masters-of-marketing.js'

export default {
  name: "Body",
  components: {
    //MainCard,
    // ourFleet,
    //ourFleetOG,
    // HostCard
  },
  data: function() {
    return {
      timer: null,
      currentDate: null,
      locationLinks: locationLinksJson,
    };
  },
  computed: {},
  mounted() {
    let externalScript = document.createElement("script");
    externalScript.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    document.head.appendChild(externalScript);
  },
  created() {},
  methods: {
    scrollFix: function(hash) {
      console.log("Scroll To");
      VueScrollTo.scrollTo(hash, 3000);
    },
  },
};
</script>
